import { render, staticRenderFns } from "./TypeView.vue?vue&type=template&id=31ba72f4&"
import script from "./TypeView.vue?vue&type=script&lang=js&"
export * from "./TypeView.vue?vue&type=script&lang=js&"
import style0 from "./TypeView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports